// Zoomy 4 — JS propio, vanilla, un archivo. Cada init comprueba su elemento antes de hacer nada.

function zmInitBarraFlotante() {
  const barra = document.querySelector('[data-zm-barra-flotante]');
  const principal = document.querySelector('[data-zm-comprar]');
  if (!barra || !principal) return;

  const boton = barra.querySelector('[data-zm-comprar-flotante]');
  if (boton) {
    boton.addEventListener('click', () => {
      if (!principal.disabled) principal.click();
    });
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const pasoDeLargo = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        barra.classList.toggle('zm-visible', pasoDeLargo);
      });
    },
    { threshold: 0 }
  );
  observer.observe(principal);
}

function zmInitComparador() {
  const comparadores = document.querySelectorAll('[data-zm-comparador]');
  comparadores.forEach((el) => {
    const wrap = el.querySelector('.zm-comparador__antes-wrap');
    const asa = el.querySelector('.zm-comparador__asa');
    if (!wrap || !asa) return;

    const mover = (clientX) => {
      const rect = el.getBoundingClientRect();
      let pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      wrap.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
      asa.style.left = pct + '%';
    };

    let arrastrando = false;
    el.addEventListener('pointerdown', (e) => {
      arrastrando = true;
      el.setPointerCapture(e.pointerId);
      mover(e.clientX);
    });
    el.addEventListener('pointermove', (e) => {
      if (!arrastrando) return;
      mover(e.clientX);
    });
    el.addEventListener('pointerup', () => (arrastrando = false));
    el.addEventListener('pointercancel', () => (arrastrando = false));
  });
}

function zmInitReveals() {
  const els = document.querySelectorAll('.zm-reveal');
  if (!els.length) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    els.forEach((el) => el.classList.add('zm-visible'));
    return;
  }

  const groups = new Map();
  els.forEach((el) => {
    const group = el.closest('[data-zm-stagger]') || el;
    const list = groups.get(group.closest('.zm-section')) || [];
    list.push(el);
    groups.set(group.closest('.zm-section'), list);
  });
  groups.forEach((list) => {
    list.forEach((el, i) => {
      el.style.setProperty('--zm-delay', `${Math.min(i, 6) * 90}ms`);
    });
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('zm-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach((el) => observer.observe(el));
}

function zmInitCifras() {
  const cifras = document.querySelectorAll('.zm-cifra__num[data-zm-hasta]');
  if (!cifras.length) return;

  const animar = (el) => {
    const hasta = parseFloat(el.dataset.zmHasta) || 0;
    const decimales = (el.dataset.zmHasta.split('.')[1] || '').length;
    const sufijo = el.dataset.zmSufijo || '';
    const duracion = 1400;
    const inicio = performance.now();
    const paso = (ahora) => {
      const progreso = Math.min((ahora - inicio) / duracion, 1);
      const facilitado = 1 - Math.pow(1 - progreso, 3);
      const valor = hasta * facilitado;
      el.textContent = valor.toLocaleString('es', { minimumFractionDigits: decimales, maximumFractionDigits: decimales }) + sufijo;
      if (progreso < 1) requestAnimationFrame(paso);
    };
    requestAnimationFrame(paso);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animar(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );
  cifras.forEach((el) => observer.observe(el));
}

function zmInitFaq() {
  const items = document.querySelectorAll('.zm-faq__item');
  if (!items.length) return;

  items.forEach((item) => {
    const boton = item.querySelector('.zm-faq__pregunta');
    const respuesta = item.querySelector('.zm-faq__respuesta');
    if (!boton || !respuesta) return;
    boton.addEventListener('click', () => {
      const abierto = item.classList.contains('zm-abierto');
      items.forEach((otro) => {
        otro.classList.remove('zm-abierto');
        const r = otro.querySelector('.zm-faq__respuesta');
        if (r) r.style.maxHeight = null;
      });
      if (!abierto) {
        item.classList.add('zm-abierto');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}

function zmInitGaleria() {
  const galerias = document.querySelectorAll('[data-zm-galeria]');
  galerias.forEach((galeria) => {
    const principal = galeria.querySelector('[data-zm-principal]');
    const minis = galeria.querySelectorAll('[data-zm-mini]');
    if (!principal || !minis.length) return;
    minis.forEach((mini) => {
      mini.addEventListener('click', () => {
        const src = mini.dataset.zmSrc;
        const srcset = mini.dataset.zmSrcset;
        if (src) principal.src = src;
        if (srcset) principal.srcset = srcset;
        minis.forEach((m) => m.classList.remove('zm-activo'));
        mini.classList.add('zm-activo');
      });
    });
  });
}

function zmInitVariantes() {
  const forms = document.querySelectorAll('[data-zm-producto]');
  forms.forEach((wrap) => {
    const datosEl = wrap.querySelector('[data-zm-variantes]');
    if (!datosEl) return;
    let variantes = [];
    try {
      variantes = JSON.parse(datosEl.textContent);
    } catch (e) {
      return;
    }

    const pills = wrap.querySelectorAll('.zm-pill[data-zm-opcion]');
    const idInput = wrap.querySelector('input[name="id"]');
    const precioEl = wrap.querySelector('[data-zm-precio]');
    const precioTachadoEl = wrap.querySelector('[data-zm-precio-tachado]');
    const stockEl = wrap.querySelector('[data-zm-stock]');
    const botonComprar = wrap.querySelector('[data-zm-comprar]');

    const seleccion = {};
    wrap.querySelectorAll('.zm-pill.zm-seleccionado[data-zm-opcion]').forEach((p) => {
      seleccion[p.dataset.zmOpcion] = p.dataset.zmValor;
    });

    const actualizar = () => {
      const encontrada = variantes.find((v) =>
        Object.keys(seleccion).every((k) => v.opciones[k] === seleccion[k])
      );
      pills.forEach((p) => {
        const opcion = p.dataset.zmOpcion;
        const valor = p.dataset.zmValor;
        const otras = { ...seleccion, [opcion]: valor };
        const existe = variantes.some(
          (v) => v.opciones[opcion] === valor && Object.keys(otras).every((k) => v.opciones[k] === otras[k] || !v.opciones[k])
        );
        const combinacionDisponible = variantes.some(
          (v) => v.opciones[opcion] === valor && v.disponible
        );
        p.classList.toggle('zm-agotado', !combinacionDisponible);
      });

      if (!encontrada) return;
      if (idInput) idInput.value = encontrada.id;
      if (precioEl) precioEl.textContent = encontrada.precio;
      if (precioTachadoEl) {
        if (encontrada.precioComparado) {
          precioTachadoEl.textContent = encontrada.precioComparado;
          precioTachadoEl.style.display = '';
        } else {
          precioTachadoEl.style.display = 'none';
        }
      }
      if (stockEl) {
        if (encontrada.disponible) {
          stockEl.textContent = stockEl.dataset.zmTextoOk || 'En stock';
          stockEl.className = 'zm-compra__stock zm-compra__stock--ok';
        } else {
          stockEl.textContent = stockEl.dataset.zmTextoAgotado || 'Agotado';
          stockEl.className = 'zm-compra__stock zm-compra__stock--agotado';
        }
      }
      if (botonComprar) {
        botonComprar.disabled = !encontrada.disponible;
        botonComprar.textContent = encontrada.disponible
          ? botonComprar.dataset.zmTextoComprar
          : botonComprar.dataset.zmTextoAgotado;
      }
    };

    pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        if (pill.classList.contains('zm-agotado')) return;
        const opcion = pill.dataset.zmOpcion;
        wrap.querySelectorAll(`.zm-pill[data-zm-opcion="${opcion}"]`).forEach((p) => p.classList.remove('zm-seleccionado'));
        pill.classList.add('zm-seleccionado');
        seleccion[opcion] = pill.dataset.zmValor;
        actualizar();
      });
    });

    actualizar();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  zmInitBarraFlotante();
  zmInitComparador();
  zmInitReveals();
  zmInitCifras();
  zmInitFaq();
  zmInitGaleria();
  zmInitVariantes();
});
